export default "__VITE_ASSET__DSpUP0mZ__"